import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Info } from '@mui/icons-material';
import { keyframes, Stack, Typography } from '@mui/material';

import { deskingSelectors } from '../../../../../model';
import { MenuCards, MenuFields, MenuSelector } from '../../../../components';

interface Props {
  createProductSlot?: ReactNode;
}

export const Menu = ({ createProductSlot }: Props) => {
  const isProposalsProductsLoading = useSelector(deskingSelectors.isProposalsProductsLoading);
  const products = useSelector(deskingSelectors.proposalsProducts);

  if (!isProposalsProductsLoading && !products.length) {
    const pulse = keyframes`
        0% { transform: scale(1); }
        50% { transform: scale(1.1); }
        100% { transform: scale(1); }
    `;

    return (
      <Stack gap="1rem" alignItems="center">
        <Info sx={{ animation: `${pulse} 2s ease-in-out infinite`, fontSize: '4rem' }} color="info" />

        <Stack>
          <Typography align="center" variant="subtitle1" component="span">
            No qualifying products available for the selected equipment.
          </Typography>

          <Typography align="center" variant="body1" component="span">
            Try selecting different equipment or contact your administrator to confirm product availability.
          </Typography>
        </Stack>
      </Stack>
    );
  }

  return (
    <>
      <MenuSelector createProductSlot={createProductSlot} />
      <MenuFields />
      <MenuCards />
    </>
  );
};
